<template>
  <div class="header">
    <span
      class="one"
      :class="{ active: isActive('/MainPage') || isActive('/') }"
    >
      <router-link to="/MainPage">首页</router-link>
    </span>
    <span class="two" :class="{ active: isActive('/communityPage') }">
      <router-link to="/communityPage">社区</router-link>
    </span>
    <span class="three" :class="{ active: isActive('/goodsPage') }">
      <router-link to="/goodsPage">周边</router-link>
    </span>
    <span class="four">
      <!-- 登录状态 @mouseleave=""-->
      <div
        v-if="isLogging"
        class="user-avatar"
        @mouseover="showDropdown = true"
      >
        <!-- 用户头像 -->
        <img :src="avatar" alt="User Avatar" class="avatar" />
        <!-- 下拉菜单 -->
        <div v-if="showDropdown" class="dropdown-menu" ref="dropdown">
          <router-link to="/userInfo" style="color: #409eff"
            >个人信息</router-link
          >
          <a href="#" @click.prevent="logout" style="color: #f56c6c"
            >退出登录</a
          >
        </div>
      </div>

      <!-- 未登录状态 -->
      <router-link v-if="!isLogging" to="/loginPage"
        ><i class="el-icon-user-solid"></i
      ></router-link>
    </span>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "PageHeader",
  data() {
    return {
      isLogging: false, // 用户登录状态，默认true
      showDropdown: false, // 控制下拉框显示
      avatar: "", //头像
    };
  },
  methods: {
    hideDropdown() {
      this.showDropdown = false;
    },
    // 退出登录逻辑
    logout() {
      this.isLogging = false;
      //删除cookie数据
      document.cookie ="isLogging=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
      document.cookie = "id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
      sessionStorage.removeItem("token"); //删除token
      sessionStorage.removeItem("role"); 
    },
    closeDropdown(event) {
      // 判断点击区域是否在头像或下拉菜单内
      if (
        this.$refs.dropdown &&
        !this.$refs.dropdown.contains(event.target) &&
        !this.$el.contains(event.target)
      ) {
        this.showDropdown = false;
      }
    },
    getInfo() {
      //获取登录时 存在cookie的用户id
      const currentId = this.getCookie("id");
      //获取token并设置请求头
      const token = sessionStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `${token}`;
      
      axios
        .get(`http://www.wjyzlj.cn/pet/user/${currentId}`)
        .then((response) => {
          this.avatar = response.data.data.headPicture;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCookie(name) {
      // 获取所有cookie字符串
      let cookies = document.cookie.split(";");
      // 遍历每个cookie
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim(); // 去除空格
        if (cookie.startsWith(name + "=")) {
          return cookie.substring(name.length + 1); // 返回cookie值
        }
      }

      return null; // 如果没有找到指定的cookie，返回null
    },
    // 检查当前路由是否激活
    isActive(path) {
      return this.$route.path === path;
    },
  },
  mounted() {
    const status = this.getCookie("isLogging"); //获取用户登录状态
    //用用户登录状态判断显示
    if (status != null) {
      this.isLogging = status;
    }
    this.getInfo();

    // 监听点击事件，判断点击是否在头像或下拉菜单外
    document.addEventListener("click", this.closeDropdown);
  },
  beforeDestroy() {
    // 移除事件监听，防止内存泄漏
    document.removeEventListener("click", this.closeDropdown);
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  height: 80px;
  background: linear-gradient(90deg, #409eff 0%, #64b5f6 100%);
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1000;
}

.one,
.two,
.three,
.four {
  position: relative;
  padding: 0 20px;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

/* 活跃菜单项样式 */
.active a {
  color: #ffffff !important;
  background: rgba(255, 255, 255, 0.2) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-2px);
}

.active a:after {
  width: 80% !important;
  height: 3px !important;
  background: #ffffff !important;
}

.one a,
.two a,
.three a {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 20px;
  transition: all 0.3s ease;
  position: relative;
}

.one a:hover,
.two a:hover,
.three a:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.one a:after,
.two a:after,
.three a:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background: #fff;
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

.one a:hover:after,
.two a:hover:after,
.three a:hover:after {
  width: 70%;
}

.user-avatar {
  position: relative;
  display: inline-block;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.user-avatar:hover {
  transform: scale(1.05);
}

.avatar {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  object-fit: cover;
}

.avatar:hover {
  border-color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.dropdown-menu {
  position: absolute;
  top: 55px;
  right: -10px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  width: 160px;
  text-align: center;
  z-index: 100;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform-origin: top center;
  animation: dropdown-appear 0.3s cubic-bezier(0.1, 0.9, 0.2, 1);
}

@keyframes dropdown-appear {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.dropdown-menu a {
  padding: 12px 16px;
  text-decoration: none;
  transition: background 0.2s;
  font-size: 14px;
  font-weight: 500;
  display: block;
}

.dropdown-menu a:first-child {
  border-bottom: 1px solid #eee;
}

.dropdown-menu a:hover {
  background-color: #f8f9fa;
}

.four i {
  font-size: 28px;
  color: white;
  transition: all 0.3s ease;
}

.four i:hover {
  color: #fff;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
  transform: scale(1.1);
}

/* 添加箭头指示下拉菜单 */
.dropdown-menu:before {
  content: "";
  position: absolute;
  top: -6px;
  right: 20px;
  width: 12px;
  height: 12px;
  background: white;
  transform: rotate(45deg);
  box-shadow: -2px -2px 5px rgba(0, 0, 0, 0.04);
}
</style>
